import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import {
  convertToDollarFraction,
  returnFractionStringQuoteValue,
  returnFractionStringZValueDecimal,
} from "@/lib/businessRules/dollarFractionBusinessRule";
import { returnDecimalFormatting, isPriceNotation } from "@/lib/globalFormatterHelper";
import { TNotation } from "@/lib/interfaces and Enums/TYPENotations";

function determineIndicativeMidNotation(
  notation: TNotation,
  isES: boolean,
  isUnwindStyle: boolean,
): TNotation {
  if (!isES) {
    return notation;
  } else if (isUnwindStyle) {
    return "bps";
  }
  return notation;
}

const IndicativeMidCellRenderer = (props: any) => {
  if (!props.data) {
    return null;
  }
  if (props.data.role == "RP") {
    return null;
  }

  const { isES, isOutright } = returnAllTradeDetailsFromGenericParams(props);

  const quoteDisplayValue = isOutright
    ? props.value?.toString() || ""
    : props.data.indicativeMid;

  const notation = props.data.notation ? props.data.notation : props.data.notationES;
  const isUnwindStyle = isES && props.data.unwind == true;
  const notationToDisplayInUI = determineIndicativeMidNotation(notation, isES, isUnwindStyle);
  const isUsingDollarFractionLogic = notation === "$fr";

  // Avoids showing "0-00" for empty indicativeMid
  if (quoteDisplayValue == "") {
    return <div className="overflow-hidden text-ellipsis justify-center text-center" style={{ width: "100%" }}></div>;
  }

  if (!isUsingDollarFractionLogic) {
    const formatted = returnDecimalFormatting(Number(quoteDisplayValue), notationToDisplayInUI);
    return (
      <div className="overflow-hidden text-ellipsis justify-center text-center" style={{ width: "100%" }}>
        {isPriceNotation(notationToDisplayInUI) ? formatted : `${formatted} ${notationToDisplayInUI}`}
      </div>
    );
  }

  // $fr path — same approach as formattedQuote.tsx (bid/ask/mid).
  // indicativeMid may arrive as a decimal; convert to $fr string if it doesn't already have a hyphen.
  const valueStr = String(quoteDisplayValue);
  const frValue = valueStr.substring(1).includes("-")
    ? valueStr
    : convertToDollarFraction(Number(valueStr));
  const frStr = String(frValue);

  // If the value cannot be expressed as a $fr fraction, fall back to decimal display.
  if (!frStr.substring(1).includes("-")) {
    return (
      <div className="overflow-hidden text-ellipsis justify-center text-center" style={{ width: "100%" }}>
        {returnDecimalFormatting(Number(valueStr), notationToDisplayInUI)}
      </div>
    );
  }

  // Apply the same functions used by bid/ask/mid in formattedQuote.tsx.
  const fakeParams = { ...props, value: frStr };
  const displayValue = returnFractionStringQuoteValue(isOutright, fakeParams);
  const zValueDecimal = returnFractionStringZValueDecimal(isOutright, fakeParams);

  return (
    <div className="overflow-hidden text-ellipsis justify-center text-center" style={{ width: "100%" }}>
      {displayValue}
      {zValueDecimal}
    </div>
  );
};

export default IndicativeMidCellRenderer;
